/**
 * Utility function to safely parse JSON from a fetch Response
 * Handles empty responses and invalid JSON gracefully
 */
export const safeParseJSON = async (response: Response): Promise<unknown> => {
  const text = await response.text();
  if (!text || text.trim() === '') {
    return {};
  }
  try {
    return JSON.parse(text);
  } catch {
    console.error('Failed to parse JSON response:', text);
    return { message: 'Invalid server response' };
  }
};

/**
 * Check if a response contains JSON content
 */
export const hasJSONContent = (response: Response): boolean => {
  const contentType = response.headers.get('content-type');
  return contentType?.includes('application/json') ?? false;
};
